import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Form, Button, Row, Col, Spinner } from "react-bootstrap";

import {
  changePlanModalStep,
  setStripeToken,
} from "../../../redux/features/plan/slice";

import {
  useStripe,
  useElements,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
function CheckoutForm({ choosedPlan, changePlanModalStep, setStripeToken }) {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);

    await stripe.createToken(elements.getElement(CardElement)).then((res) => {
      if (res.error) {
        setLoading(false);
      } else {
        setLoading(false);
        let token = res.token.id;

        setStripeToken(token);
        changePlanModalStep("payment");
      }
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <CardElement />
      {/* <Row>
        <Col sm={12}>
          <Form.Group className="form-group">
            <Form.Label>Card Number</Form.Label>
            <CardNumberElement className="form-control" />
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group className="form-group" controlId="validationFormik1">
            <Form.Label>Expiration</Form.Label>
            <CardExpiryElement className="form-control" />
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group className="form-group" controlId="validationFormik1">
            <Form.Label>Security Code</Form.Label>
            <CardCvcElement className="form-control" />
          </Form.Group>
        </Col>
      </Row> */}

      <footer>
        <div className="total-bill">
          <p>Total Bill</p>
          <p>
            <span>
              {+choosedPlan.price_usd > 0
                ? choosedPlan.discountCode
                  ? choosedPlan.discountPrice.USD.priceWithDiscount
                  : choosedPlan.price_usd
                : "Free"}
            </span>
            <span>/ {choosedPlan.name.toLowerCase()}</span>
          </p>
        </div>

        <div className="actions pt-0">
          <div
            className="back"
            onClick={() => changePlanModalStep("choose-method")}
          >
            Back
          </div>

          <Button variant="info" type="submit" size="lg">
            Upgrade Account
            {loading && (
              <div className="spinner-holder">
                <Spinner animation="border" variant="white" size="sm" />
              </div>
            )}
          </Button>
        </div>
      </footer>
    </Form>
  );
}

CheckoutForm.propTypes = {
  choosedPlan: PropTypes.object.isRequired,
  changePlanModalStep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  choosedPlan: state.planReducer.choosedPlan,
});

const mapDispatchToProps = {
  changePlanModalStep,
  setStripeToken,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
